<template>
  <div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component :is="tab.component" :popupParam="popupParam" :task="task" />
      </template>
    </c-tab>
  </div>
</template>

<script>
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "constructionRelactionTask",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopConstructionId: "",
      }),
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: "workPermit",
      tabItems: [
        // 작업허가서
        {
          name: "workPermit",
          icon: "info",
          label: "LBL0000214",
          component: () =>
            import(`${"./constructionRelactionTaskWorkPermit.vue"}`),
        },
        // 위험성평가
        {
          name: "riskAssess",
          icon: "info",
          label: "LBL0000334",
          component: () =>
            import(`${"./constructionRelactionTaskRiskAssess.vue"}`),
        },
        // 관리책임자<br>패트롤
        {
          name: "safetyCheck",
          icon: "info",
          label: "관리책임자<br>패트롤",
          component: () =>
            import(`${"./constructionRelactionTaskSafetyCheck.vue"}`),
        },
        // TBM
        // { name: 'tbm', icon: 'info', label: 'LBL0001830', component: () => import(`${'./constructionRelactionTaskTbm.vue'}`) },
        // // 수급업체<br/>평가
        // { name: 'vendorAssess', icon: 'info', label: 'LBL0001831', component: () => import(`${'./constructionRelactionTaskVendorAssess.vue'}`) },
        // 부적합/<br/>시정조치
        {
          name: "impr",
          icon: "info",
          label: "LBL0001833",
          component: () => import(`${"./constructionRelactionTaskImpr.vue"}`),
        },
      ],
      task: {
        insertUrl: "",
        deleteUrl: "",
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    tabHeight() {
      return String(this.contentHeight - 50) + "px";
    },
  },
  watch: {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.task.insertUrl =
        transactionConfig.sop.scm.construction.task.insert.url;
      this.task.deleteUrl =
        transactionConfig.sop.scm.construction.task.delete.url;
      // code setting
      // list setting
    },
  },
};
</script>
